const INSTITUTE_NAME = 'Bharat Industrial Training';
const CITY = 'Noida';
const PHONE = '88518 68521';

const COURSE_SEO = {
  'PLC / SCADA Full Course': {
    title: 'PLC SCADA Course in Noida | Bharat Training',
    description: 'Join PLC SCADA course in Noida with hands-on PLC panels, SCADA projects, industrial automation practice, certification and placement support at Bharat Industrial Training.',
    keywords: ['PLC course Noida', 'SCADA training Noida', 'PLC SCADA course fees Noida', 'industrial automation institute Noida'],
  },
  'Industrial Automation': {
    title: 'Industrial Automation Course in Noida | Bharat Training',
    description: 'Industrial Automation course in Noida with PLC, sensors, drives, control panels, practical factory workflows, certification and placement support.',
    keywords: ['industrial automation course Noida', 'automation training institute Noida', 'PLC automation training'],
  },
  'SAP Full Course': {
    title: 'SAP Course in Noida with Placement | Bharat Training',
    description: 'Learn SAP in Noida with job-oriented modules, live case studies, certification guidance and placement support from Bharat Industrial Training.',
    keywords: ['SAP course Noida', 'SAP training Noida', 'SAP course with placement Noida'],
  },
  'Full Stack Developer': {
    title: 'Full Stack Developer Course in Noida | Bharat Training',
    description: 'Full Stack Developer course in Noida covering MERN skills, portfolio projects, internship guidance and placement support.',
    keywords: ['full stack developer course Noida', 'MERN stack course Noida', 'web development training Noida'],
  },
  'Data Analyst': {
    title: 'Data Analyst Course in Noida | Bharat Training',
    description: 'Data Analyst course in Noida with Excel, Power BI, dashboard projects, reporting skills and placement support.',
    keywords: ['data analyst course Noida', 'Power BI course Noida', 'Excel training Noida'],
  },
  'Data Science': {
    title: 'Data Science Course in Noida | Bharat Training',
    description: 'Data Science course in Noida with Python, machine learning, real AI projects, certification and placement support.',
    keywords: ['data science course Noida', 'Python data science training Noida', 'machine learning course Noida'],
  },
  'Digital Marketing': {
    title: 'Digital Marketing Course in Noida | Bharat Training',
    description: 'Digital Marketing course in Noida covering SEO, social media, Google Ads, analytics, live campaigns and certification.',
    keywords: ['digital marketing course Noida', 'SEO course Noida', 'Google Ads training Noida'],
  },
  'SEO Mastery': {
    title: 'SEO Course in Noida | Bharat Training',
    description: 'SEO course in Noida with keyword research, technical SEO, on-page optimization, ranking tools and live projects.',
    keywords: ['SEO course Noida', 'SEO training Noida', 'Google ranking course Noida'],
  },
};

export function slugifyCourseTitle(title) {
  return title
    .toLowerCase()
    .normalize('NFKD')
    .replace(/&/g, ' and ')
    .replace(/\+/g, ' plus ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function buildCourseDescription(course) {
  return `Learn ${course.title} in ${CITY} with practical training, live projects, certification guidance and placement support at ${INSTITUTE_NAME}. Duration: ${course.duration}. Call ${PHONE}.`;
}

function buildCourseKeywords(course) {
  const custom = COURSE_SEO[course.title]?.keywords ?? [];
  return [
    ...custom,
    `${course.title} course in ${CITY}`,
    `${course.title} training in ${CITY}`,
    `${course.category} course in ${CITY}`,
    'Bharat Training',
  ].join(', ');
}

export const allCourses = [
  { category: 'Automation', title: 'PLC / SCADA Full Course', duration: '3 Months', price: '₹24,999', features: ['100% Lab Practical', 'Industry Grade Projects', 'Placement Support'], img: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600', badge: 'Top Pick' },
  { category: 'ERP', title: 'SAP Full Course', duration: '3 Months', price: '₹24,999', features: ['Job Oriented Module', 'Live Case Studies', 'Placement Support'], img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600', badge: 'Placement' },
  { category: 'Automation', title: 'Industrial Automation', duration: '3 Months', price: '₹24,999', features: ['Real PLC Panels', 'Hands-on Tools', 'Certification'], img: 'https://leantransitionsolutions.com/assets/img/blog/Industrial_Automation.jpg' },
  { category: 'IT', title: 'Full Stack Developer', duration: '6 Months', price: '₹24,999', features: ['MERN Stack', 'Internship + Portfolio', 'Placement Support'], img: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=600', badge: 'Popular' },
  { category: 'Design', title: 'AutoCAD 2D / 3D / HVAC', duration: '6 Months', price: '₹23,999', features: ['Architecture Projects', 'HVAC Design', 'Certification'], img: 'https://corizo.in/wp-content/uploads/2025/02/Auto-CAD.jpg' },
  { category: 'Electrical', title: 'Electrical Design & Drafting', duration: '3 Months', price: '₹19,999', features: ['Industrial Drawings', 'Live Calculations', 'Certification'], img: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600' },
  { category: 'IT', title: 'Data Analyst', duration: '4 Months', price: '₹24,999', features: ['Power BI + Excel', 'Live Dashboards', 'Placement Support'], img: 'https://d2nzy1qhita6w.cloudfront.net/media/magefan_blog/data-analysis-skills-duties-responsibilities.jpeg', badge: 'In Demand' },
  { category: 'IT', title: 'Data Science', duration: '6 Months', price: '₹27,999', features: ['Python + ML', 'Real AI Projects', 'Placement Support'], img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQep9YbEPmgoMxrFRjnktYDVSePZcuLMoEqhw&s', badge: 'Placement' },
  { category: 'Electronics', title: 'Embedded System', duration: '4 Months', price: '₹22,999', features: ['Microcontrollers', 'IoT Practical', 'Placement Support'], img: 'https://images.unsplash.com/photo-1517077304055-6e89abbf09b0?w=600' },
  { category: 'Marketing', title: 'SEO Mastery', duration: '3 Months', price: '₹14,999', features: ['Google Ranking', 'Live Tools', 'Certification'], img: 'https://www.adlift.com/wp-content/uploads/2023/05/Benefits-of-SEO.webp', badge: 'Placement' },
  { category: 'Guidance', title: 'After 12th – Career Guidance', duration: 'Expert Help', price: null, features: ['Stream Selection', 'College Admissions', 'Counselling'], img: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=600', highlight: true },
  { category: 'Computer', title: 'MIS (Management Information System)', duration: '3 Months', price: '₹19,999', features: ['Excel Advanced', 'Data Management', 'Reporting Tools'], img: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600' },
  { category: 'Computer', title: 'Tally Prime', duration: '2 Months', price: '₹12,999', features: ['GST & Taxation', 'Accounting', 'Inventory Management'], img: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600', badge: 'Popular' },
  { category: 'Computer', title: 'Basic Computer Skills', duration: '1 Month', price: '₹8,999', features: ['Windows OS', 'MS Office', 'Internet Basics'], img: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=600' },
  { category: 'Computer', title: 'GST Certification', duration: '1.5 Months', price: '₹14,999', features: ['GST Filing', 'Returns', 'Practical Cases'], img: 'https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=600' },
  { category: 'Language', title: 'Spoken English', duration: '2 Months', price: '₹9,999', features: ['Fluency', 'Grammar', 'Public Speaking', 'Interview Prep'], img: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?w=600', badge: 'New' },
  { category: 'Marketing', title: 'Digital Marketing', duration: '3 Months', price: '₹19,999', features: ['SEO', 'Social Media', 'Google Ads', 'Analytics'], img: 'https://www.smart-academy.in/wp-content/uploads/2025/10/Digital-marketing-1024x576.jpg', badge: 'In Demand' },
].map(course => {
  const seo = COURSE_SEO[course.title] ?? {};
  return {
    ...course,
    slug: slugifyCourseTitle(course.title),
    seoTitle: seo.title ?? `${course.title} Course in ${CITY} | Bharat Training`,
    seoDescription: seo.description ?? buildCourseDescription(course),
    keywords: buildCourseKeywords(course),
  };
});

export const courseNames = allCourses.map(c => c.title);

export function getCoursePath(courseOrSlug) {
  if (typeof courseOrSlug === 'string') return `/courses/${courseOrSlug}`;
  return `/courses/${courseOrSlug.slug ?? slugifyCourseTitle(courseOrSlug.title)}`;
}

export function getCourseBySlug(slug) {
  return allCourses.find(course => course.slug === slug);
}

export function getCourseFaqs(course) {
  const feeAnswer = course.price
    ? `The ${course.title} fee is ${course.price}. You can contact Bharat Training for current offers, EMI options and batch details.`
    : `The ${course.title} counselling program is guided by our admission team. Contact Bharat Training for the latest schedule.`;

  return [
    {
      question: `Is ${course.title} available in Noida?`,
      answer: `Yes. ${course.title} is available at Bharat Industrial Training, Sector-3, Noida with practical learning and counselling support.`,
    },
    {
      question: `What is the duration of ${course.title}?`,
      answer: `The duration is ${course.duration}. Batch timing can vary, so students should confirm the latest schedule before admission.`,
    },
    {
      question: `What is the fee for ${course.title}?`,
      answer: feeAnswer,
    },
    {
      question: `Does this course include placement support?`,
      answer: `Yes. Bharat Training provides placement support, resume guidance, interview preparation and recruiter connects for eligible students.`,
    },
  ];
}
